export const isPermissionError = (error: unknown): boolean =>
  !!error && typeof error === 'object' && 'status' in error && (error as { status: number }).status === 403;
